import { render, staticRenderFns } from "./dashboard.compoment.vue?vue&type=template&id=53a536b6&scoped=true"
import script from "./dashboard.compoment.vue?vue&type=script&lang=ts"
export * from "./dashboard.compoment.vue?vue&type=script&lang=ts"
import style0 from "../dashboard.style.scss?vue&type=style&index=0&id=53a536b6&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a536b6",
  null
  
)

export default component.exports